import {User} from './'
import {FLOW_UNITS} from "./"

class Command {
    constructor(id=null, controller=null, sent=null, sentBy=null, response=null, retries=null, status=null,
                requestDataUpdate=null, requestEEPROMLogin= null, rate=null, units=null, remoteStartStopSetting=null,
                batchEnable=null, batchSetpoint=null, batchTotalReset=null, cellSMSEnabled=null, phoneSlot=null,
                phoneNumber=null, controlLinksSetting=null, scheduledStartMode=null, scheduledStartTime=null,
                scheduledStopMode=null, scheduledStopTime=null, userTotalReset=null, waterTotalReset=null,
                fieldNumber=null, tankLevel=null) {
        this.id = id
        this.controller = controller
        this.sent = sent
        this.sentBy = sentBy
        this.response = response
        this.retries = retries
        this.status = status
        this.requestDataUpdate = requestDataUpdate
        this.requestEEPROMLogin = requestEEPROMLogin
        this.rate = rate
        this.units = units
        this.remoteStartStopSetting = remoteStartStopSetting
        this.batchEnable = batchEnable
        this.batchSetpoint = batchSetpoint
        this.batchTotalReset = batchTotalReset
        this.cellSMSEnabled = cellSMSEnabled
        this.phoneSlot = phoneSlot
        this.phoneNumber = phoneNumber
        this.controlLinksSetting = controlLinksSetting
        this.scheduledStartMode = scheduledStartMode
        this.scheduledStartTime = scheduledStartTime
        this.scheduledStopMode = scheduledStopMode
        this.scheduledStopTime = scheduledStopTime
        this.userTotalReset = userTotalReset
        this.waterTotalReset = waterTotalReset
        this.fieldNumber = fieldNumber
        this.tankLevel = tankLevel
        this.toAPIObject = this.toAPIObject.bind(this)
        this.splitByCommandGroup = this.splitByCommandGroup.bind(this)
    }

    static fromAPIObject(obj) {
        let user = obj.sent_by
        if (obj.sent_by) {
            user = User.fromAPIObject(obj.sent_by)
        }
        return new Command(obj.id, obj.controller, obj.sent, user, obj.response, obj.retries, obj.status,
            obj.request_data_update, obj.request_login_EEPROM, obj.rate, obj.units, obj.remote_start_stop_setting,
            obj.batch_enable, obj.batch_setpoint, obj.batch_total_reset, obj.cell_sms_enabled,
            obj.phone_slot, obj.phone_number, obj.control_links_setting, obj.scheduled_start_mode,
            obj.scheduled_start_time, obj.scheduled_stop_mode, obj.scheduled_stop_time,
            obj.user_total_reset, obj.water_total_reset, obj.field_number, obj.tank_level)
    }

    get date() {
        if (!this.sent) {
            return "-"
        }
        let sent = new Date(this.sent)

        let day = `${sent.getDate()}`
        if (day.length < 2) {
            day = "0" + day
        }

        let month = `${sent.getMonth()+1}`
        if (month.length < 2) {
            month = "0" + month
        }

        let year = `${sent.getYear()-100}`

        return `${month}/${day}/${year}`
    }

    get user() {
        if (this.sentBy && this.sentBy.name) {
            return this.sentBy.name
        } else {
            return "-"
        }
    }

    get change() {
        let name = []
        if (this.rate !== undefined && this.rate !== null) {
            let units = (this.units !== null && this.units !== undefined ? FLOW_UNITS[this.units] : "")
            name.push(`set rate to ${this.rate} ${units}`)
        } else if (this.units !== undefined && this.units !== null) {
            // TODO get units name
            name.push(`set flow units to ${this.units}`)
        }

        if (this.batchEnable !== undefined && this.batchEnable !== null) {
            name.push(`${this.batchEnable ? "enabl" : "disabl"}ed batch mode`)
        }

        if (this.batchSetpoint !== undefined && this.batchSetpoint !== null) {
            let units = (this.units !== null && this.units !== undefined ? FLOW_UNITS[this.units] : "")
            name.push(`set batch setpoint to ${this.batchSetpoint} ${units}`)
        }

        if (this.userTotalReset) {
            name.push('reset controller total')
        }
        if (this.batchTotalReset) {
            name.push('reset batch total')
        }
        if (this.waterTotalReset) {
            name.push('reset water total')
        }
        if (this.cellSMSEnabled) {
            name.push('enabled cell SMS')
        }
        if (this.phoneSlot && this.phoneNumber) {
            name.push(`set phone #${this.phoneSlot} to ${this.phoneNumber}`)
        }
        if (this.controlLinksSetting) {
            name.push(`set server refresh mode to ${this.controlLinksSetting > 1 ? "repeating" : "refresh once"}`)
        }

        if (this.scheduledStartMode && this.scheduledStartTime && this.scheduledStartTime.slice) {
            let startTime = this.scheduledStartTime.slice(0,5)
            name.push(`scheduled start at ${startTime}${this.scheduledStartMode > 1 ? " every day": ""}`)
        } else if (this.scheduledStartMode === 0) {
            name.push("disabled scheduled start")
        }
        if (this.scheduledStopMode && this.scheduledStopTime && this.scheduledStopTime.slice) {
            let stopTime = this.scheduledStopTime.slice(0,5)
            name.push(`scheduled stop at ${stopTime}${this.scheduledStopMode > 1 ? " every day": ""}`)
        } else if (this.scheduledStopMode === 0) {
            name.push("disabled scheduled stop")
        }

        if (this.remoteStartStopSetting !== null && this.remoteStartStopSetting !== undefined) {
            name.push(this.remoteStartStopSetting > 1 ? "started pump" : "stopped pump")
        }

        if (this.requestDataUpdate) {
            name.push("requested new data")
        }

        if (this.requestEEPROMLogin) {
            name.push("requested load EEPROM Login")
        }

        if (this.fieldNumber) {
            name.push(`set field number to ${this.fieldNumber}`)
        }

        if (this.tankLevel) {
            name.push(`set tank level to ${this.tankLevel/10}`)
        }

        if (name.length > 2) {
            name[name.length-1] = `and ${name[name.length-1]}`
            let nameStr = name.join(", ")
            return nameStr.charAt(0).toUpperCase() + nameStr.substr(1)
        } else if (name.length > 1) {
            name[name.length-1] = `and ${name[name.length-1]}`
            let nameStr = name.join(" ")
            return nameStr.charAt(0).toUpperCase() + nameStr.substr(1)
        } else if (name.length > 0) {
            let nameStr = name[0]
            return nameStr.charAt(0).toUpperCase() + nameStr.substr(1)
        } else {
            return ""
        }
    }

    splitByCommandGroup() {
        let command = this.toAPIObject()
        // temp hack for demo
        let controller = command.controller
        let rate = command.rate
        let units = command.units
        let remote_start_stop_setting = command.remote_start_stop_setting
        let newCommand = {
            controller,
            rate,
            units,
            remote_start_stop_setting
        }
        return [Command.fromAPIObject(newCommand)]
        // end hack


        let changedSettings = []
        let commandGroups = [['phone_slot', 'phone_number'],
            ['rate', 'units', 'remote_start_stop_setting'],
            ['batch_enable', 'batch_setpoint', 'batch_total_reset'],
            ['cell_sms_enabled'],
            ['phone_slot', 'phone_number'],
            ['control_links_setting'],
            ['scheduled_start_mode', 'scheduled_start_time', 'scheduled_stop_mode', 'scheduled_stop_time'],
            ['user_total_reset', 'water_total_reset'],
            ['field_number'],
            ['tank_level']]

        let previousGroup = commandGroups[0]
        let commands = []
        let commandObject = {controller:command.controller}
        for (let i = 0; i < commandGroups.length; i++) {
            let group = commandGroups[i]
            let skipToNextCommandGroup = false
            console.log(`Now on group ${i}`)
            console.log(group)
                for (let j = 0; j < group.length; j++) {
                    let commandName = group[j]
                    let commandValueNull = (command[commandName] === undefined || command[commandName] === null)
                    // if we reach a null command value or the end of commands
                    if (!skipToNextCommandGroup && ((commandValueNull && changedSettings.length) || i === (commandGroups.length - 1))) {
                        // move on to next command and next group
                        console.log(commandObject)
                        if (Object.keys(commandObject).length > 1) {
                            console.log("Adding command obj")
                            console.log(commandObject)
                            commands.push(Command.fromAPIObject(commandObject))
                            commandObject = {controller: command.controller}
                            skipToNextCommandGroup = true
                        }
                        console.log("skipping command group")
                        console.log(group)
                    }

                    // if we have changed something in this group but are missing a previous change
                    if (changedSettings.length > 0 && !skipToNextCommandGroup) {
                        let previousChange = changedSettings[changedSettings.length - 1]
                        if (!group.includes(previousChange) && !previousGroup.includes(previousChange)) {
                            if (Object.keys(commandObject).length > 1) {
                                console.log("Adding command obj2")
                                console.log(commandObject)
                                commands.push(Command.fromAPIObject(commandObject))
                                commandObject = {controller: command.controller}
                            }
                        }
                    }

                    // otherwise if the command has a value set it on the new obj
                    if (!commandValueNull && !skipToNextCommandGroup) {
                        changedSettings.push(commandName)
                        commandObject[commandName] = command[commandName]
                    }
                }
            previousGroup = group
        }
        console.log("Commands are")
        console.log(commands)
        return commands
    }

    toAPIObject() {
        let command = {
            controller: this.controller
        }

        if (this.requestDataUpdate !== null && this.requestDataUpdate !== undefined) {
            command['request_data_update'] = this.requestDataUpdate
        }
        if (this.requestEEPROMLogin !== null && this.requestEEPROMLogin !== undefined) {
            command['request_login_EEPROM'] = this.requestEEPROMLogin
        }
        if (this.rate !== null && this.rate !== undefined) {
            command['rate'] = this.rate
        }
        if (this.units !== null && this.units !== undefined) {
            command['units'] = this.units
        }
        if (this.remoteStartStopSetting !== null && this.remoteStartStopSetting !== undefined) {
            command['remote_start_stop_setting'] = this.remoteStartStopSetting
        }
        if (this.batchEnable !== null && this.batchEnable !== undefined) {
            command['batch_enable'] = this.batchEnable
        }
        if (this.batchSetpoint !== null && this.batchSetpoint !== undefined) {
            command['batch_setpoint'] = this.batchSetpoint
        }
        if (this.batchTotalReset !== null && this.batchTotalReset !== undefined) {
            command['batch_total_reset'] = this.batchTotalReset
        }
        if (this.scheduledStartMode !== null && this.scheduledStartMode !== undefined) {
            command['scheduled_start_mode'] = this.scheduledStartMode
        }
        if (this.scheduledStartTime !== null && this.scheduledStartTime !== undefined) {
            command['scheduled_start_time'] = this.scheduledStartTime
        }
        if (this.scheduledStopMode !== null && this.scheduledStopMode !== undefined) {
            command['scheduled_stop_mode'] = this.scheduledStopMode
        }
        if (this.scheduledStopTime !== null && this.scheduledStopTime !== undefined) {
            command['scheduled_stop_time'] = this.scheduledStopTime
        }
        if (this.userTotalReset !== null && this.userTotalReset !== undefined) {
            command['user_total_reset'] = this.userTotalReset
        }
        if (this.waterTotalReset !== null && this.waterTotalReset !== undefined) {
            command['water_total_reset'] = this.waterTotalReset
        }
        if (this.fieldNumber !== null && this.fieldNumber !== undefined) {
            command['field_number'] = this.fieldNumber
        }
        if (this.tankLevel !== null && this.tankLevel !== undefined) {
            command['tank_level'] = this.tankLevel * 10
        }

        // These are only for legacy
        if (this.phoneSlot !== null && this.phoneSlot !== undefined) {
            command['phone_slot'] = this.phoneSlot
        }
        if (this.phoneNumber !== null && this.phoneNumber !== undefined) {
            command['phone_number'] = this.phoneNumber
        }

        // These only need set by support
        if (this.cellSMSEnabled !== null && this.cellSMSEnabled !== undefined) {
            command['cell_sms_enabled'] = this.cellSMSEnabled
        }
        if (this.controlLinksSetting !== null && this.controlLinksSetting !== undefined) {
            command['control_links_setting'] = this.controlLinksSetting
        }

        return command
    }
}

export default Command




// WEBPACK FOOTER //
// ./src/models/Command.js